import React from 'react';
import { useTheme } from 'styled-components';
import { Flex, Text } from 'core/components';

export function initialsOf(name = '') {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}

/** The author's initials in a small neutral circle, as the thread variant of the comments shows them. */
const CommentAvatar = ({ name }) => {
  const theme = useTheme();

  return (
    <Flex
      width={26}
      height={26}
      flex="0 0 auto"
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      bg={theme.backgrounds.specialMuted}
      color={theme.colors.muted}
    >
      <Text fontSize={10} fontWeight="medium" color="inherit">
        {initialsOf(name) || '?'}
      </Text>
    </Flex>
  );
};

export default CommentAvatar;
